(() => {
  // Évite une double initialisation si le fichier est chargé plusieurs fois.
  if (window.__freeShippingProgressInitialized) return;
  window.__freeShippingProgressInitialized = true;

  const FREE_SHIPPING_PROGRESS = {
    // false = fonctionnalité complètement désactivée
    // true  = fonctionnalité active + test A/B
    enabled: false,

    thresholdTest: {
      storageKey: 'ab_test_shipping_bar',
      attributeKey: 'ab_test_shipping_bar',

      // A = jauge affichée
      // B = jauge masquée
      hiddenVariant: 'B'
    }
  };

  /*
   * Styles de contrôle injectés au niveau global.
   * Cela permet de conserver le masquage même si Shopify
   * reconstruit dynamiquement le panier.
   */
  function injectControlStyles() {
    if (document.getElementById('free-shipping-progress-control-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'free-shipping-progress-control-style';

    style.textContent = `
      html.free-shipping-progress-disabled [data-free-shipping-progress],
      html.ab-test-shipping-bar-hidden [data-free-shipping-progress] {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  injectControlStyles();

  /*
   * Feature désactivée :
   * - pas de test A/B
   * - pas de lecture du panier
   * - pas d'attribut panier
   * - jauge masquée partout
   */
  if (!FREE_SHIPPING_PROGRESS.enabled) {
    document.documentElement.classList.add(
      'free-shipping-progress-disabled'
    );

    document.documentElement.classList.remove(
      'ab-test-shipping-bar-hidden'
    );

    return;
  }

  document.documentElement.classList.remove(
    'free-shipping-progress-disabled'
  );

  function getShippingBarVariant() {
    const config = FREE_SHIPPING_PROGRESS.thresholdTest;

    let variant = localStorage.getItem(config.storageKey);

    if (!['A', 'B'].includes(variant)) {
      variant = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(config.storageKey, variant);
    }

    return variant;
  }

  function applyShippingBarVisibility() {
    const config = FREE_SHIPPING_PROGRESS.thresholdTest;
    const variant = getShippingBarVariant();

    document.documentElement.classList.toggle(
      'ab-test-shipping-bar-hidden',
      variant === config.hiddenVariant
    );
  }

  async function syncShippingBarVariant(cart) {
    if (!cart.item_count) return;

    const config = FREE_SHIPPING_PROGRESS.thresholdTest;
    const variant = getShippingBarVariant();

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              [config.attributeKey]: variant
            }
          })
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      console.error('AB test shipping bar:', error);
    }
  }

  class FreeShippingProgress {
    constructor(element) {
      this.element = element;
      this.threshold = Number(element.dataset.threshold);

      this.text = element.querySelector(
        '.free-shipping-progress__text'
      );

      this.bar = element.querySelector(
        '.free-shipping-progress__bar span'
      );

      this.progressbar = element.querySelector(
        '.free-shipping-progress__bar'
      );
    }

    update(totalPrice) {
      if (
        !this.threshold ||
        !this.text ||
        !this.bar ||
        !this.progressbar
      ) {
        return;
      }

      const amountLeft = this.threshold - totalPrice;

      const progress = Math.min(
        Math.max((totalPrice / this.threshold) * 100, 0),
        100
      );

      const success = amountLeft <= 0;

      this.element.classList.toggle(
        'free-shipping-progress--success',
        success
      );

      if (success) {
        this.text.innerHTML = `
          <span class="free-shipping-progress__check">✓</span>
          <strong>Livraison offerte débloquée !</strong>
        `;

        this.text.classList.add(
          'free-shipping-progress__success-text'
        );
      } else {
        const amount = new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(amountLeft / 100);

        this.text.innerHTML =
          `Plus que <strong>${amount}</strong> pour profiter de la livraison offerte`;

        this.text.classList.remove(
          'free-shipping-progress__success-text'
        );
      }

      this.bar.style.width = `${progress}%`;

      this.progressbar.setAttribute(
        'aria-valuenow',
        Math.round(progress)
      );
    }
  }

  async function updateFreeShippingProgress() {
    applyShippingBarVisibility();

    const config = FREE_SHIPPING_PROGRESS.thresholdTest;
    const variant = getShippingBarVariant();

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const cart = await response.json();

      await syncShippingBarVariant(cart);

      // Variante B : la jauge reste masquée.
      if (variant === config.hiddenVariant) {
        return;
      }

      const elements = document.querySelectorAll(
        '[data-free-shipping-progress]'
      );

      elements.forEach((element) => {
        new FreeShippingProgress(element).update(
          cart.total_price
        );
      });
    } catch (error) {
      console.error('Free shipping progress:', error);
    }
  }

  function initFreeShippingProgress() {
    applyShippingBarVisibility();

    updateFreeShippingProgress();

    const notification = document.getElementById(
      'cart-notification'
    );

    if (!notification) return;

    const observer = new MutationObserver(() => {
      if (notification.classList.contains('active')) {
        updateFreeShippingProgress();
      }
    });

    observer.observe(notification, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initFreeShippingProgress
    );
  } else {
    initFreeShippingProgress();
  }
})();